import { createAsyncThunk } from "@reduxjs/toolkit";
import RecommendationsAPI, { 
    GenerateRecommendationRequest,
    UpdateRecommendationsRequest,
    GetRecommendationParams,
    RecommendationAPIResponse,
} from '../../../api/Recommendations';
import { MessageResponse } from "../../../api/common";

export const createRecommendationsThunk = createAsyncThunk<
    RecommendationAPIResponse,
    GenerateRecommendationRequest,
    { rejectValue: string }
>(
    'recommendations/generate',
    async (request: GenerateRecommendationRequest, { rejectWithValue }) => {
        try {
            return await RecommendationsAPI.create(request);
        } catch (error: any) {
            console.error(error);
            return rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to generate recommendations'
            );
        }
    }
);

export const getRecommendationsThunk = createAsyncThunk<
    RecommendationAPIResponse,
    GetRecommendationParams,
    { rejectValue: string }
>(
    'recommendations/get',
    async (params: GetRecommendationParams, { rejectWithValue }) => {
        try {
            return await RecommendationsAPI.get(params);
        } catch (error: any) {
            console.error(error);
            return rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to fetch recommendations'
            );
        }
    }
);

export const updateRecommendationsThunk = createAsyncThunk<
    MessageResponse,
    { caseId: string; request: UpdateRecommendationsRequest },
    { rejectValue: string }
>(
    'recommendations/update',
    async ({ caseId, request }, { rejectWithValue }) => {
        try {
            return await RecommendationsAPI.update(caseId, request);
        } catch (error: any) {
            console.error(error);
            return rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to update recommendations'
            );
        }
    }
);
